import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './onboarding.css';
import techglass from '../assets/techglass.png';
import Button from '../components/button';
import arrow from '../assets/arrow.svg';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const Onboarding = () => {
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const screenRef = useRef(null);

  useGsapAnimations(screenRef, page);

  const slides = [
    {
      number: '01',
      title: (
        <>
          INTERACTIVE <br />
          IMPERSIVE <br />
          <span>EXPERIENCE</span>
        </>
      ),
      text: 'Experience innovation that blends technology, creativity, and human connection into one unforgettable journey.',
      className: 'slide_1'
    },
    {
      number: '02',
      title: (
        <>
          THE <br />
          FUTURE <br />
          IS <span>FLUID</span>
        </>
      ),
      text:  
      <>
        Explore innovation, visionary <br /> startups, and future <br /> technology.
        </>,
      className: 'slide_2'
    },
    {
      number: '03',
      title: (
        <>
          CONNECT <br />
          EXPLORE <br />
          <span>EVOLVE</span>
        </>
      ),
      text: 'Book sessions, navigate the exhibition, collect digital tickets, and experience Techne in a whole new way.',
      className: 'slide_3'
    }
  ];

  const nextSlide = () => {
    if (page < 2) {
      setPage(page + 1);
    } else {
      navigate('/login');
    }
  };

  return (
    <main className='onboarding_page'>
      <section className={`onboarding_screen ${slides[page].className}`} ref={screenRef}>

        <h1 className='onboarding_number' data-gsap-intro>{slides[page].number}</h1>

        <img className='onboarding_img' src={techglass} alt='' />

        <div className='onboarding_text' data-gsap-intro>
          <h2>{slides[page].title}</h2>
          <p>{slides[page].text}</p>
        </div>

        <div className='onboarding_bottom' data-gsap-intro>
          <div className='onboarding_dots'>
            {slides.map((slide, index) => (
              <button
                aria-label={`Go to onboarding slide ${index + 1}`}
                aria-current={page === index ? 'step' : undefined}
                className={page === index ? 'active_dot' : ''}
                key={slide.className}
                onClick={() => setPage(index)}
                type="button"
              />
            ))}
          </div>

          <Button
            className='btnstyle3'
            img={arrow}
            aria-label={page < 2 ? 'Next onboarding slide' : 'Finish onboarding'}
            onClick={nextSlide}
          />
        </div>

      </section>
    </main>
  );
};

export default Onboarding;
